import firebase from 'firebase'
import 'firebase/auth'

var config = {
    apiKey: "AIzaSyA6cCTB2uk975E2L_Ez2y3Cocfkoaqbu3I",
    authDomain: "granola-notes.firebaseapp.com",
    projectId: "granola-notes",
    storageBucket: "granola-notes.appspot.com",
    messagingSenderId: "653089632197",
    appId: "1:653089632197:web:9d44bc7a23b2c0e59625ac",
    measurementId: "G-GNQC4088J2"
}

const fire = firebase.initializeApp(config)
export const auth = fire.auth()
export const provider = new firebase.auth.GoogleAuthProvider()
export default fire;